// src/pages/Terms.jsx
// 이용약관. 법적 문서라 영어로 통일.
import { Link } from 'react-router-dom';
import SEO from '../components/SEO.jsx';

const CONTACT_EMAIL = 'liger4903@gmail.com'; // TODO(citizencast): 운영 연락처로 확인/변경
const EFFECTIVE = '2026-05-26';

export default function Terms() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-10">
      <SEO title="Terms of Service" description="CitizenCast Terms of Service" path="/terms" />
      <h1 className="text-2xl font-bold mb-1">Terms of Service</h1>
      <p className="text-xs text-gray-500 mb-6">Last updated: {EFFECTIVE}</p>

      <div className="space-y-5 text-sm text-gray-700 leading-relaxed">
        <p>By using CitizenCast (“the Service”) you agree to these terms.</p>

        <section>
          <h2 className="font-bold text-base">1. The Service</h2>
          <p>CitizenCast converts political news links into short AI-generated videos. AI output may contain inaccuracies; you are responsible for reviewing content before publishing or sharing it.</p>
        </section>

        <section>
          <h2 className="font-bold text-base">2. Your responsibilities</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>You are solely responsible for the factual accuracy and legality (e.g., defamation) of any video you download, share, or upload.</li>
            <li>You may connect only YouTube channels you own or are authorized to manage.</li>
            <li>No unlawful, hateful, deceptive, or prohibited (weapons, gambling, adult) content.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-bold text-base">3. Payments</h2>
          <p>Subscriptions are processed by Polar.sh as Merchant of Record. Plans, credits, cancellations, and refunds follow the pricing page and Polar.sh’s policies.</p>
        </section>

        <section>
          <h2 className="font-bold text-base">4. YouTube</h2>
          <p>YouTube features are subject to the <a className="underline" href="https://www.youtube.com/t/terms" target="_blank" rel="noreferrer">YouTube Terms of Service</a>. Uploads occur only to channels you authorize via Google OAuth.</p>
        </section>

        <section>
          <h2 className="font-bold text-base">5. Disclaimer &amp; liability</h2>
          <p>The Service is provided “as is” without warranties. To the extent permitted by law, we are not liable for damages arising from AI-generated content or your use of the Service.</p>
        </section>

        <section>
          <h2 className="font-bold text-base">6. Contact</h2>
          <p><a className="underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></p>
        </section>

        <p className="pt-2"><Link className="underline" to="/privacy">Privacy Policy →</Link></p>
      </div>
    </div>
  );
}
